import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
export var IconSize;

(function (IconSize) {
  IconSize["sm"] = "sm";
  IconSize["md"] = "md";
  IconSize["lg"] = "lg";
  IconSize["xl"] = "xl";
})(IconSize || (IconSize = {}));

export var getSize = function getSize(size) {
  switch (size) {
    case IconSize.sm:
      return '1em';

    case IconSize.md:
      return '1.5em';

    case IconSize.lg:
      return '2em';

    case IconSize.xl:
      return '3em';

    default:
      return '1em';
  }
};
var currentId = 0;
/**
 * Factory to create Icon class components for consumers
 */

export function createIcon(_ref) {
  var name = _ref.name,
      _ref$xOffset = _ref.xOffset,
      xOffset = _ref$xOffset === void 0 ? 0 : _ref$xOffset,
      _ref$yOffset = _ref.yOffset,
      yOffset = _ref$yOffset === void 0 ? 0 : _ref$yOffset,
      width = _ref.width,
      height = _ref.height,
      svgPath = _ref.svgPath,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? '' : _ref$transform;

  var _a;

  return _a =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(SVGIcon, _React$Component);

    function SVGIcon() {
      var _this;

      _classCallCheck(this, SVGIcon);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(SVGIcon).apply(this, arguments));
      _this.id = "icon-title-".concat(currentId++);
      return _this;
    }

    _createClass(SVGIcon, [{
      key: "render",
      value: function render() {
        var _a = this.props,
            size = _a.size,
            color = _a.color,
            title = _a.title,
            noVerticalAlign = _a.noVerticalAlign,
            props = __rest(_a, ["size", "color", "title", "noVerticalAlign"]);

        var hasTitle = Boolean(title);
        var heightWidth = getSize(size);
        var baseAlign = -0.125 * Number.parseFloat(heightWidth);
        var style = noVerticalAlign ? null : {
          verticalAlign: "".concat(baseAlign, "em")
        };
        var viewBox = [xOffset, yOffset, width, height].join(' ');
        return React.createElement("svg", Object.assign({
          style: style,
          fill: color,
          height: heightWidth,
          width: heightWidth,
          viewBox: viewBox,
          "aria-labelledby": hasTitle ? this.id : null,
          "aria-hidden": hasTitle ? null : true,
          role: "img"
        }, props), hasTitle && React.createElement("title", {
          id: this.id
        }, title), React.createElement("path", {
          d: svgPath,
          transform: transform
        }));
      }
    }]);

    return SVGIcon;
  }(React.Component), _a.displayName = name, _a.defaultProps = {
    color: 'currentColor',
    size: IconSize.sm,
    noVerticalAlign: false
  }, _a;
}